export default __webpack_public_path__ + "static/media/sun.c083fc15.png";